<template>
  <v-snackbar
    v-model="showSnackbar"
    color="success"
    timeout="8000"
    :bottom="position === 'bottom'"
    :top="position === 'top'"
    >
      {{ msg }}
    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="showSnackbar = false"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBarSuccess',
  props: [
    'msg',
    'position',
  ],
  data: () => ({
    showSnackbar: false
  }),
  methods: {
    show: function() {
      if( this.showSnackbar ) { // flashes snackbar
        this.showSnackbar = false;
        setTimeout( () => this.showSnackbar = true, 300 )
      } else {
        this.showSnackbar = true;
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/utils/SnackbarSuccess.vue